import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import {TA_MODULE, FEATURES} from '../../../utils/constant' ;

class UserRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "roles", readItems: { module_name: "TA" } })
      .then((dataArray) => {
        let roles = dataArray.data.resultSet;
        this.setState({
          rowData: isEmpty(dataArray) ? [] : roles,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_USER_ROLE.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-user-role", {
      ...rowData,
      title: "editpermission",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/userrole");
    this.props.history.go();
  };

  
  redirectToEditUserRole = (item) => {
    console.log(item);
    this.props.history.push({
      pathname: "/edit-user-role",
      state: { item: item },
      title: "editpermission"
    });
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      // {
      //   headerName: t("table.username") || "User Code",
      //   field: "roleId",
      //   sortable: true,
      //   filter: true,
      // },
      {
        headerName: t("table.username") || "User Role",
        field: "role",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table.edit/delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_USER_ROLE.UPDATE && !this.props.permissions.TA_USER_ROLE.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          actionButton={false}
          rowData={rowData}
          titleBarTitle={t("title") || "User Role"}
          titleBarLink={"/edit-user-role"}
          baseURL={"roles"}
          keyIndex={"roleId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          redirectToEditUserRole={this.redirectToEditUserRole}
          hideRowEdit={!this.props.permissions.TA_USER_ROLE.UPDATE}
          hideRowDelete={!this.props.permissions.TA_USER_ROLE.DELETE}
          moduleName = {TA_MODULE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("user_role")(UserRole));
